import { Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Wind as WindIcon } from '../atoms/icons/wind';
import { ChartBox } from '../molecules/chart-box';
import { SwitchBox } from '../molecules/switch-box';
import { ValueBox } from '../molecules/value-box';
import { Group } from '../organisms/group';
import { FormattedStatus } from '../store/formatted-status';
import { FormattedValue } from '../store/formatted-value';
import { Battery } from '../atoms/icons/battery';
import { ElectricalGrid } from '../atoms/icons/electrical-grid';

const Wind = () => {
  return (
    <>
      <Group layout="list">
        <SwitchBox
          title={
            <FormattedMessage
              id="wind.status"
              defaultMessage="Režim větrné elektrárny"
            />
          }
          subtitle={<FormattedStatus type="wind" />}
          fullWidth
        />
      </Group>

      <Group
        layout="list"
        title={
          <FormattedMessage id="wind.statistics" defaultMessage="Statistiky" />
        }
      >
        <Typography variant="h3">
          <FormattedMessage
            id="wind.statistics.power"
            defaultMessage="Výkon větrné elektrárny"
          />
        </Typography>
        <ChartBox variableId="WIND_POWER_GRAPH" />

        <Typography variant="h3" sx={{ mt: 2 }}>
          <FormattedMessage
            id="wind.statistics.wind_speed"
            defaultMessage="Rychlost větru"
          />
        </Typography>
        <ChartBox variableId="WIND_SPEED_GRAPH" />

        {/* <Typography variant="h3" sx={{ mt: 2 }}>
          <FormattedMessage
            id="wind.statistics.battery_charge_power"
            defaultMessage="Výkon do baterie"
          />
        </Typography>
        <ChartBox variableId="WIND_BATTERY_CHARGE_POWER_GRAPH" /> */}

        {/* <Typography variant="h3" sx={{ mt: 2 }}>
          <FormattedMessage
            id="wind.statistics.load_current"
            defaultMessage="Proud do odporu"
          />
        </Typography>
        <ChartBox variableId="WIND_LOAD_CURRENT_GRAPH" /> */}
      </Group>

      <Group
        title={
          <FormattedMessage
            id="wind.common"
            defaultMessage="Obecné informace"
          />
        }
        layout="list"
      >
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.common.power"
              defaultMessage="Aktuální výkon"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_POWER"
              opts={{
                style: 'unit',
                unit: 'kilowatt',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<WindIcon />}
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.statistics.wind_speed"
              defaultMessage="Rychlost větru"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_SPEED"
              opts={{
                style: 'unit',
                unit: 'meter-per-second',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<WindIcon />}
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.common.battery_power"
              defaultMessage="Výkon do baterie"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_BATTERY_POWER"
              opts={{
                style: 'unit',
                unit: 'kilowatt',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<Battery />}
        />
        {/* <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.common.battery_voltage"
              defaultMessage="Napětí baterie"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_BATTERY_VOLTAGE"
              opts={{
                style: 'unit',
                unit: 'voltage',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<WindIcon />}
        /> */}
        {/* <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.common.battery_current"
              defaultMessage="Proud baterie"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_BATTERY_CURRENT"
              opts={{
                style: 'unit',
                unit: 'ampere',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<WindIcon />}
        /> */}
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.common.resistor_power"
              defaultMessage="Výkon do odporu"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_RESISTOR_POWER"
              opts={{
                style: 'unit',
                unit: 'kilowatt',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<ElectricalGrid />}
        />
        <ValueBox
          type="row"
          title={
            <FormattedMessage
              id="wind.common.power_total"
              defaultMessage="Celková výroba"
            />
          }
          value={
            <FormattedValue
              variableId="WIND_PRODUCED_TOTAL"
              opts={{
                style: 'unit',
                unit: 'kilowatt-hour',
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              }}
            />
          }
          icon={<WindIcon />}
          expanded={
            <Typography variant="body1" sx={{ color: 'text.disabled', mt: 1 }}>
              <FormattedMessage
                id="wind.common.power_today"
                defaultMessage="Dnešní výroba:"
              />
              &nbsp;
              <FormattedValue
                variableId="WIND_PRODUCED_TODAY"
                opts={{
                  style: 'unit',
                  unit: 'kilowatt-hour',
                  maximumFractionDigits: 1,
                  minimumFractionDigits: 1,
                }}
              />
              <br />
              <FormattedMessage
                id="wind.common.power_year"
                defaultMessage="Roční výroba:"
              />
              &nbsp;
              <FormattedValue
                variableId="WIND_PRODUCED_YEAR"
                opts={{
                  style: 'unit',
                  unit: 'kilowatt-hour',
                  maximumFractionDigits: 1,
                  minimumFractionDigits: 1,
                }}
              />
              <br />
              <FormattedMessage
                id="wind.common.battery_charged_total"
                defaultMessage="Celkem do baterie:"
              />
              &nbsp;
              <FormattedValue
                variableId="WIND_BATTERY_CHARGE_TOTAL"
                opts={{
                  style: 'unit',
                  unit: 'kilowatt-hour',
                  maximumFractionDigits: 1,
                  minimumFractionDigits: 1,
                }}
              />
            </Typography>
          }
        />
      </Group>
    </>
  );
};

export default Wind;
